module.exports = __webpack_public_path__ + "img/03.b9470cb8.jpg";